// extracted by mini-css-extract-plugin
export var brandLockup = "_jf-5";
export var brandLogo = "_jf-6";
export var bullet = "_jf-1i";
export var bulletText = "_jf-1h";
export var bullets = "_jf-1c";
export var callout = "_jf-12";
export var calloutBody = "_jf-14";
export var calloutLabel = "_jf-13";
export var checkIcon = "_jf-1e";
export var checkList = "_jf-1b";
export var checkSvg = "_jf-1f";
export var checkText = "_jf-1g";
export var choiceCard = "_jf-x";
export var choiceDescription = "_jf-10";
export var choiceIcon = "_jf-11";
export var choiceText = "_jf-y";
export var choiceTitle = "_jf-z";
export var closeButton = "_jf-d";
export var codeText = "_jf-28";
export var compactPage = "_jf-f";
export var content = "_jf-9";
export var contentColumn = "_jf-3";
export var coverageCard = "_jf-o";
export var coverageDescription = "_jf-24";
export var coverageTitle = "_jf-23";
export var eyebrow = "_jf-i";
export var fieldCard = "_jf-m";
export var fieldDescription = "_jf-r";
export var fieldError = "_jf-s";
export var fieldHeader = "_jf-p";
export var fieldTitle = "_jf-q";
export var finalNote = "_jf-29";
export var footer = "_jf-a";
export var fulfillmentBody = "_jf-1u";
export var fulfillmentBodyText = "_jf-1v";
export var fulfillmentRow = "_jf-1r";
export var fulfillmentRows = "_jf-1q";
export var fulfillmentTitle = "_jf-1t";
export var header = "_jf-4";
export var heading = "_jf-h";
export var helperText = "_jf-1k";
export var indented = "_jf-1x";
export var inlineLink = "_jf-26";
export var inlineTitle = "_jf-2a";
export var intro = "_jf-k";
export var linkPreview = "_jf-1z";
export var listItem = "_jf-1d";
export var main = "_jf-1";
export var marketingImage = "_jf-c";
export var marketingPanel = "_jf-b";
export var modal = "_jf-0";
export var noteBody = "_jf-v";
export var noteBodyText = "_jf-w";
export var noteCard = "_jf-n";
export var noteIcon = "_jf-t";
export var noteTitle = "_jf-u";
export var numberBadge = "_jf-2e";
export var numberedStep = "_jf-2c";
export var numberedStepBody = "_jf-2f";
export var numberedStepCta = "_jf-2d";
export var numberedStepDescription = "_jf-2h";
export var numberedStepTitle = "_jf-2g";
export var numberedSteps = "_jf-2b";
export var page = "_jf-e";
export var playCircle = "_jf-18";
export var playIcon = "_jf-19";
export var policyBody = "_jf-21";
export var policyHeader = "_jf-20";
export var policyPreview = "_jf-1y";
export var policyTitle = "_jf-22";
export var progressFill = "_jf-8";
export var progressTrack = "_jf-7";
export var pseudoLink = "_jf-25";
export var pseudoLinkIcon = "_jf-27";
export var rowHeader = "_jf-1s";
export var section = "_jf-g";
export var shell = "_jf-2";
export var statusIconSuccess = "_jf-1m";
export var statusIconSvg = "_jf-1o";
export var statusIconWarning = "_jf-1n";
export var statusRow = "_jf-1l";
export var statusText = "_jf-1p";
export var stepTitle = "_jf-j";
export var strongText = "_jf-1w";
export var subHeading = "_jf-l";
export var videoEmbed = "_jf-16";
export var videoIframe = "_jf-17";
export var videoLabel = "_jf-1a";
export var videoPlaceholder = "_jf-15";
export var warningIcon = "_jf-1j";